import base from "./base.service";

const authorizedInstance = base.service(true);

export const getAllAccounts = () => {
  return authorizedInstance.get(`/Account/all-accounts`);
};
export const getAllAccountsWithoutPlayroom = () => {
  return authorizedInstance.get(`/Account/get-all-without-playroom`);
};

export const registerAccount = (accountData) => {
  return authorizedInstance.post(`/Account/register`, accountData);
};
// export const confirmReservation = (id) => {
//   return authorizedInstance.get(`/Booking/confirm-reservation/${id}`);
// };

export const getCurrentAccount = () => {
  return authorizedInstance.post("/Account/get-user");
}


export default {
  getAllAccounts,
  registerAccount,
  getAllAccountsWithoutPlayroom,
    getCurrentAccount,
  // confirmReservation,
  // rejectReservation,
};
